import { render, staticRenderFns } from "./ServicepointsFilter.vue?vue&type=template&id=5357299a&scoped=true"
import script from "./ServicepointsFilter.vue?vue&type=script&lang=ts"
export * from "./ServicepointsFilter.vue?vue&type=script&lang=ts"
import style0 from "./ServicepointsFilter.vue?vue&type=style&index=0&id=5357299a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5357299a",
  null
  
)

export default component.exports